import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../../services/commande-client/data.service';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-avoir-negoce',
  templateUrl: './avoir-negoce.component.html',
  styleUrls: ['./avoir-negoce.component.scss']
})
export class AvoirNegoceComponent implements OnInit {

    currentStatus: string = 'tous';
    statuses: { path: string; label: string; status: string }[] = [
        { path: 'tous', label: 'Tous', status: 'Tous' },
        { path: 'brouillon', label: 'Brouillon', status: 'Brouillon' },
        { path: 'non-utilise', label: 'Non utilisé', status: 'Non utilisé' },
        { path: 'partiellement-utilise', label: 'Partiellement utilisé', status: 'Partiellement utilisé' },
        { path: 'utilise', label: 'Utilisé', status: 'Utilisé' },
        { path: 'annule', label: 'Annulé', status: 'Annulé' }
    ];
    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Avoir négoce',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        { label: 'PDF', action: () => this.exportService.triggerPDF(), icon: '../../../assets/images/logo/pdf_logo.png' },
                        { label: 'CSV', action: () => this.exportToCSV(), icon: '../../../assets/images/logo/csv_logo.png' }
                    ]
                }
            ]
        });
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments?.length > 0 ? segments[0].path : 'tous';
            const item = this.statuses.find(s => s.path === path);
            this.currentStatus = item ? item.path : 'tous';
        });
    }

    filterByStatus(path: string, status: string) {
        this.currentStatus = path;
        this.dataService.filterAvoirByStatus(status);
        this.router.navigate([`/vente-negoce/avoir/${path}`]);
    }

    getStatusCount(status: string): number {
        const data = this.dataService.getAvoirTableData() || [];
        return status === 'Tous' ? data.length : data.filter((i: any) => i.status === status).length;
    }

    private exportToCSV(): void {
        const avoirs = this.dataService.getAvoirTableData() || [];
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Statut'];
        const rows = avoirs.map((item: any) => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map((row: string[]) => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'avoir.csv');
    }
}
